import { render } from "./Tp.vue?vue&type=template&id=125e5b28&scoped=true"
import script from "./Tp.vue?vue&type=script&lang=js"
export * from "./Tp.vue?vue&type=script&lang=js"

import "./Tp.vue?vue&type=style&index=0&id=125e5b28&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/lemmi_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-125e5b28"]])

export default __exports__